export default "/assets/ad0353d0c8b2aab1.png"